const languageMap = {
    en: {name: 'English', default: true},
    es: {name: 'Spanish', default: true},
    fr: {name: 'French'},
    de: {name: 'German'},
    hi: {name: 'Hindi'},
    it: {name: 'Italian'},
};

export default languageMap;
